<template>
  <div class="home light-theme">
    <!-- 添加调试信息显示 -->
    <div v-if="false"
      style="position: fixed; top: 0; left: 0; background: rgba(0,0,0,0.8); color: white; padding: 10px; z-index: 9999;">
      isCollapsed: {{ isCollapsed }}
    </div>
    <div class="bodydiv">
      <!-- 侧边栏 -->
      <aside :class="{ collapsed: isCollapsed }" @mouseenter="showCollapseIcon = true"
        @mouseleave="showCollapseIcon = false">
        <div class="sidebar-toggle-btn" @click.stop="toggleCollapse" v-if="!isCollapsed && showCollapseIcon">
          <i class="fas fa-angle-double-left"></i>
        </div>
        <div class="logotitle" @click="backhome('backhomepage')" v-show="!isCollapsed">
          <!-- <i class="el-icon-cherry"></i> -->
          <img :src="home_logo" alt="" />
          <!-- <span>EasyNoteAI</span> -->
        </div>

        <!-- 展开按钮独立为一个菜单项，在折叠状态下显示 -->
        <div class="sidebar-toggle-btn expand-btn" v-if="isCollapsed" @click.stop="toggleCollapse">
          <i class="fas fa-angle-double-right"></i>
        </div>

        <ul>
          <li @click="backhome('backhomepage')" :class="{ 'center-icon': isCollapsed }">
            <!-- <i class="el-icon-s-home"></i> -->
            <img :src="noteasidekey === 'dashboard' ? dashboardActive : dashboardNormal" alt="">
            <span v-show="!isCollapsed">Dashboard</span>
          </li>
          <li :class="{ liactiveis: noteasidekey == 'notes', 'center-icon': isCollapsed }" @click="gopageurl('notes')">
            <!-- <i class="el-icon-edit-outline"></i> -->
            <img :src="noteasidekey === 'notes' ? notesActive : notesNormal" alt="">
            <span v-show="!isCollapsed">Notes</span>
          </li>
          <li v-if="false" :class="{ liactiveis: noteasidekey == 'mindmap', 'center-icon': isCollapsed }"
            @click="gopageurl('mindmap')">
            <!-- <i class="el-icon-edit-outline"></i> -->
            <img :src="noteasidekey === 'mindmap' ? mindmapActive : mindmapNormal" alt="">
            <span v-show="!isCollapsed">Mind Map</span>
            <span v-if="notclick == 0 && !isCollapsed" class="new">New</span>
          </li>
          <li v-if="false && noteobj?.filetype !== 'record'"
            :class="{ liactiveis: noteasidekey == 'chatbot', 'center-icon': isCollapsed }"
            @click="gopageurl('chatbot')">
            <!-- <i class="el-icon-chat-square"></i> -->
            <img :src="noteasidekey === 'chatbot' ? chatbotActive : chatbotNormal" alt="">
            <span v-show="!isCollapsed">Chat Bot</span>
          </li>
          <li v-if="false" :class="{ liactiveis: noteasidekey == 'flashcards', 'center-icon': isCollapsed }"
            @click="gopageurl('flashcards')">
            <!-- <i class="el-icon-files"></i> -->
            <img :src="noteasidekey === 'flashcards' ? flashcardsActive : flashcardsNormal" alt="">
            <span v-show="!isCollapsed">Flashcards</span>
          </li>
          <li v-if="false" :class="{ liactiveis: noteasidekey == 'quiz', 'center-icon': isCollapsed }"
            @click="gopageurl('quiz')">
            <!-- <i class="el-icon-c-scale-to-original"></i> -->
            <img :src="noteasidekey === 'quiz' ? quizActive : quizNormal" alt="">
            <span v-show="!isCollapsed">Quiz</span>
          </li>
          <li v-if="false" :class="{ liactiveis: noteasidekey == 'transcript', 'center-icon': isCollapsed }"
            @click="gopageurl('transcript')">
            <!-- <i class="el-icon-document"></i> -->
            <img :src="noteasidekey === 'transcript' ? transcriptActive : transcriptNormal" alt="">
            <span v-show="!isCollapsed">Transcript</span>
          </li>
          <li v-if="false" :class="{ liactiveis: noteasidekey == 'settings', 'center-icon': isCollapsed }"
            @click="gopageurl('settings')">
            <!-- <i class="el-icon-s-tools"></i> -->
            <img :src="noteasidekey === 'settings' ? settingActive : settingNormal" alt="">
            <span v-show="!isCollapsed">Settings</span>
          </li>
        </ul>
        <div class="gopaypage" @click="gopaypage" v-show="!isCollapsed">
          ✨ Upgrade to Premium
        </div>

        <div class="acount acount_notes" :class="{ 'center-icon': isCollapsed }">
          <div class="signin-collapsed" v-if="isCollapsed" @click="gopageurl('settings')">
            <img :src="userimg" alt="" />
          </div>
          <div class="signin" v-if="!isCollapsed" @click="gopageurl('settings')">
            <!-- <i class="el-icon-user-solid"></i> -->
            <img :src="userimg" alt="" />
            <span v-show="!isCollapsed">{{ email }}</span>
          </div>
        </div>
      </aside>

      <!-- 主页面 -->
      <main class="mainview">

        <div class="titlebox" v-if="noteobj?.notename">
          <div class="titlebox-l">
            <div class="title-editor">
              <template v-if="!isEditingTitle">
                <div class="title-text" @mouseenter="showEditIcon = true" @mouseleave="showEditIcon = false">
                  {{ noteobj?.notename }}
                  <span class="title-edit-icon" v-show="showEditIcon" @click.stop="startEditTitle">
                    <i class="fas fa-pen"></i>
                  </span>
                </div>
              </template>
              <template v-else>
                <input class="title-input" type="text" v-model="editingTitleText" ref="titleInput"
                  @keyup.enter="saveTitle" />
                <span class="title-save-icon" @click.stop="saveTitle">
                  <i class="fas fa-check"></i>
                </span>
              </template>
            </div>
            <div class="title_date">{{ formatDateTime(noteobj?.createtime) }}</div>
          </div>
          <div class="filedownload"
            v-if="false && noteobj?.filename && (noteobj.filetype == 'record' || noteobj.filetype == 'audio') && isdownloadable">
            <div class="download" @click="saveaudio(noteobj)">
              <!-- <span>Save Audio Locally</span> -->
              <span>{{ noteobj?.filename }}</span>
            </div>
          </div>
          <div class="export" v-if="false && noteasidekey == 'notes'">
            <div class="copyas" @click="closeRightPanel">
              <i class="el-icon-close"></i> Close
            </div>
          </div>
        </div>
        <!-- 骨架屏加载效果 -->
        <div class="titlebox-skeleton" v-else>
          <div class="titlebox-l-skeleton">
            <div class="title-editor-skeleton">
              <div class="title-text-skeleton"></div>
              <div class="title-action-btn-skeleton"></div>
            </div>
            <div class="title-date-skeleton"></div>
          </div>
          <div class="filedownload-skeleton" v-if="noteobj?.filetype == 'record' || noteobj?.filetype == 'audio'">
            <div class="download-skeleton"></div>
          </div>
        </div>

        <!-- 添加进度步骤组件 -->
        <transition name="fade">
          <ProcessSteps v-if="currentProcessStep" 
            :processSteps="processSteps"
            :currentStepText="currentStepText" />
        </transition>

        <div class="notes-container" v-if="noteasidekey == 'notes'" :class="{ 'with-translate': showTranslate }">
          <NewNotePage v-bind:noteobj="noteobj" @right-panel-closed="handleRightPanelClosed"
            @right-panel-opened="handleRightPanelOpened" @setquiz="setquiz" @setflashcards="setflashcards"
            @deletenote="deletenote" @tryagain="tryagain" />
        </div>
      </main>
    </div>
    <popup_price v-if="ispricepopup" @closePricePopup="closePricePopup" />
  </div>
</template>

<script>
import NewNotePage from "@/views/newnotes/comd/new_note_page.vue";
import ProcessSteps from "@/components/ProcessSteps.vue";
// import notenotes from "@/views/pages/components/note_notes.vue";
// import notetranscript from "@/views/pages/components/note_transcript.vue";
// import TranslateToggle from "@/views/pages/components/translate_toggle.vue";
// import notechatbot from "@/views/pages/components/note_chatbot.vue";
// import noteflashcards from "@/views/pages/components/note_flashcards.vue";
// import notequiz from "@/views/pages/components/note_quiz.vue";
// import notesetting from "@/views/pages/components/note_settting.vue";
// import notechangetitle from "@/views/pages/components/popups/popup_changetitle.vue";
// import notemindmap from "@/views/pages/components/note_mindmap.vue";
import popup_price from "@/views/pages/index_page/popups/popup_price.vue";
export default {
  components: {
    NewNotePage,
    // notenotes,
    // notetranscript,
    // TranslateToggle
    // notechatbot,
    // noteflashcards,
    // notequiz,
    // notesetting,
    // notechangetitle,
    // notemindmap,
    ProcessSteps,
    popup_price
  },
  name: "HomeIndexpage",
  data() {
    return {
      noteasidekey: "notes",
      home_logo: require("@/assets/images/index/logo1.png"),
      userimg: require("@/assets/images/home/userimg.png"),

      // 非选中状态图标
      dashboardNormal: require("@/assets/images/home/normal/dashboard.png"),
      notesNormal: require("@/assets/images/home/normal/noteicon.png"),


      // 选中状态图标
      dashboardActive: require("@/assets/images/home/active/dashboard.png"),
      notesActive: require("@/assets/images/home/active/noteicon.png"),


      showpaybtn: false,
      noteobj: { status: -1 },

      questionsI: [],
      transcript: {},

      timer: null,

      email: "",
      notclick: 0,
      isdownloadable: false,
      showTranslate: false,
      targetLanguage: 'zh',
      translatedContent: '',
      isCollapsed: false,
      isDarkTheme: true, // 固定使用深色主题
      isEditingTitle: false,
      editingTitleText: "",
      titleWidth: 0,
      isRightPanelClosed: false, // 新增：跟踪右侧面板状态
      showEditIcon: false, // 控制编辑图标显示
      showCollapseIcon: false, // 控制折叠图标显示

      ispricepopup: false,
      currentProcessStep: '',  // 当前处理步骤
      processSteps: [],       // 处理步骤数组
      currentStepText: '',    // 当前步骤描述
      stepStartTimes: {},     // 步骤开始时间记录
      completedSteps: {},     // 已完成步骤的处理时间记录
      pollingTimer: null,     // 轮询定时器
      pollingInterval: 1000,  // 初始轮询间隔（毫秒）
      maxPollingInterval: 5000, // 最大轮询间隔
      consecutiveEmptyCount: 0, // 连续空结果计数
      apiBaseUrl: "https://easynoteai.online",
      currentAskId: null,      // 当前askId，用于轮询
      currentNoteId: null,     // 当前noteId，用于轮询
    };
  },

  watch: {
    noteasidekey() {
      // 在 noteasidekey 变化时，将滚动条位置重置到最顶部
      // console.log("newVal", newVal);
      this.$nextTick(() => {
        document.querySelector(".mainview").scrollTop = 0;
      });
    },
    '$route.params': 'handleRouteParams',
    noteobj(newVal) {
      this.isdownloadable = newVal?.createtime > '2024-12-15';
    }
  },
  mounted() {
    this.handleRouteParams();
    this.email = this.$cookies.get("email");
    this.notclick = this.$cookies.get("notclick") || 0;

    // 在挂载时读取折叠状态
    try {
      const savedState = this.$cookies.get("menuCollapsed");
      if (savedState !== null && savedState !== undefined) {
        this.isCollapsed = JSON.parse(savedState);
      }
    } catch (error) {
      console.error("Error reading collapse state:", error);
    }

    // 设置深色主题
    localStorage.setItem('easynote-theme-preference', 'dark');
  },
  methods: {
    closePricePopup() {
      this.ispricepopup = false;
    },
    setflashcards(falshcard) {
      this.noteobj.note_cards = falshcard;
    },
    setquiz(quiz) {
      this.noteobj.note_quiz = quiz;
    },
    async handleRouteParams() {
      const { noteid, askid, mode } = this.$route.params;

      console.log("noteid", this.$route.params, mode, askid);

      // 如果有askid，说明是新建笔记，需要开始轮询
      if (askid) {
        this.currentAskId = askid;
        this.currentNoteId = noteid;
        
        // 保存askid到sessionStorage，用于页面刷新后恢复
        this.saveAskIdToStorage(askid, noteid);
        
        this.startPolling(askid, noteid);
        return;
      }

      let this_noteid = noteid;
      if (!this_noteid) {
        this_noteid = this.$route.params.note?.noteid;
      }
      if (!this_noteid && this.$route.params?.pagekey) {
        this_noteid = this.getNoteIdFromCookie();
      }
      if (!this_noteid) {
        // 跳转到home页面
        this.$router.push({
          name: "Homeindex",
        });
        return;
      }

      // 如果noteobj为空，则获取笔记
      if (this.noteobj.status != 1) {
        await this.getnotes(this_noteid);
        
        // 获取笔记后，检查笔记状态
        if (this.noteobj.status === 0) {
          // 笔记还在生成中，尝试从前端存储获取askId并开始轮询
          await this.checkAndContinuePollingFromStorage(this_noteid);
        }
      }
      this.saveNoteIdToCookie(this_noteid); // 将 noteid 存到 cookie

      const pagekey = this.$route.params.pagekey;
      if (pagekey) {
        // 根据 URL 中的 pagekey 展示相应组件
        this.chooseaside(pagekey);
        return;
      }
      if (mode) {
        this.chooseaside(mode);
      }

    },
    setupTimer(noteid) {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getnotes(noteid);
      }, 2000);
    },
    saveNoteIdToCookie(noteid) {
      this.$cookies.set("noteid", noteid, { path: "/" });
    },
    setnoteobj(noteobj) {
      this.noteobj = noteobj;
    },
    removeNoteIdFromCookie() {
      this.$cookies.remove("noteid");
    },
    getNoteIdFromCookie() {
      return this.$cookies.get("noteid");
    },
    backhome(isget) {
      this.$router.push({
        name: "Homeindex",
        params: { dontgetmynotes: isget },
      });
    },
    openchangetitle() {
      this.$refs.pchangetitle.openModal();
    },
    gopaypage() {
      this.$router.push({
        name: "IndexPage", // 目标路由的名称
        params: { pagekey: "price" }, // 通过 params 传递参数
        // query: { category: "electronics" }, // 通过 query 传递参数
      });
      // this.ispricepopup = true;   // 弹窗方式
    },
    async getnotes(noteid, status = 0) {
      if (status == 10) {
        this.noteobj.status = 0;
      }
      try {
        const respne = await this.$axios.post("api/getnotes/", {
          noteid: noteid,
        });
        const redata = respne.data;
        if (redata.code == 200) {
          this.noteobj = redata.noteobj;
          this.noteobj.status = 1;
          clearInterval(this.timer);
        }
        if (redata.code == 201) {
          this.$message({
            center: true,
            message: "The note does not exist",
            type: "warning",
          });
          clearInterval(this.timer);
        }
        if (redata.code == 202) {
          // 笔记还在生成中，设置完整的noteobj信息，避免显示骨架屏
          this.noteobj = redata.noteobj;
          this.noteobj.status = 0;
        }
        if (redata.code == 203) {
          this.noteobj = redata.noteobj;
          clearInterval(this.timer);
        }
      } catch (error) {
        clearInterval(this.timer);
        console.log("error", error);
      }
    },
    async tryagain() {
      try {
        // console.log("tryagain", this.noteobj);
        const noteid = this.noteobj?.noteid;
        const res = await this.$axios.post("api/renotes_ask/", {
          noteid: noteid
        });
        const redata = res.data;
        if (redata.code == 200) {
          this.getnotes(redata.noteid);
          this.setupTimer(noteid);
        } else if (redata.code == 201) {
          this.$message({
            center: true,
            message: redata.messages,
            type: "warning",
          });
        }


      } catch (error) {
        console.error(error);
      }
    },
    savenotes(notetitle) {
      // console.log("修改笔记标题notetitle", notetitle);
      this.$set(this.noteobj, "notename", notetitle);
      // 保存新笔记名称到数据库
      this.$axios.post("api/updatenotename/", {
        noteid: this.noteobj.noteid,
        notename: notetitle,
      });
    },
    async deletenote() {
      const noteid = this.noteobj.noteid;
      const subid = this.$cookies.get("subid");
      // console.log("删除笔记", noteid);
      await this.$axios.post("api/deletenote/", {
        noteid: noteid,
        subid: subid,
      });

      this.backhome("get");
    },
    gopageurl(key) {
      console.log("gopageurl", key);
      if (key == 'home') {
        this.showhome = {
          showhome_home: 'home',
          timestr: new Date().getTime()
        };
      }

      this.$router.push({
        name: "Homeindex_key", // 目标路由的名称
        params: { pagekey: key }, // 通过 params 传递参数
        // query: { category: "electronics" }, // 通过 query 传递参数
      });
    },
    chooseaside(key) {
      this.noteasidekey = key;
      switch (key) {
        case "notes":
          // 切换到notes页面时，通知子组件当前主题状态为深色
          this.$nextTick(() => {
            this.$emit('theme-changed', true);
          });
          break;
        case "chatBot":
          break;
        case "flashcards":
          break;
        case "quiz":
          this.questionsI = this.noteobj?.note_quiz;
          for (let i = 0; i < this.questionsI?.length; i++) {
            // ischooes: false,
            // chooese: -1,
            this.$set(this.questionsI[i], "ischooes", false);
            this.$set(this.questionsI[i], "chooese", -1);
          }
          break;
        case "transcript":

          if (this.noteobj.filetype == 'record') {
            this.transcript["value"] = this.noteobj?.live_transcript;
            this.transcript["notetoken"] = this.noteobj?.notetoken;
          } else {
            this.transcript["value"] = this.noteobj?.note_transcript;
            this.transcript["notetoken"] = this.noteobj?.notetoken;
          }
          this.transcript["type"] = this.noteobj?.filetype;

          // 切换到transcript页面时，通知子组件当前主题状态为深色
          this.$nextTick(() => {
            this.$emit('theme-changed', true);
          });

          break;
        case "settings":
          break;
        default:
          break;
      }
    },
    formatDateTime(dateTime) {
      if (!dateTime) return "";
      const date = new Date(dateTime);
      const options = {
        weekday: "long", // 添加星期几
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      };
      return date.toLocaleString("en-US", options);
    },
    async saveaudio(noteobj) {

      const fileKey = noteobj.filepath;
      const filename = noteobj.filename;

      try {
        this.$message.info('Starting download...');

        // 获取下载链接
        const { data } = await this.$axios.post('/api/get_download_url/', {
          noteid: noteobj.noteid,
          fileKey: fileKey
        });

        if (!data.downloadUrl) {
          throw new Error('Failed to get download URL');
        }

        // 使用 fetch 获取文件内容
        const response = await fetch(data.downloadUrl);
        if (!response.ok) {
          throw new Error('Download failed');
        }

        // 获取文件 blob
        const blob = await response.blob();

        // 创建 blob URL
        const blobUrl = window.URL.createObjectURL(blob);

        // 创建下载链接
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename; // 设置下载文件名
        link.style.display = 'none';

        // 添加到文档并触发点击
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        this.$message.success('Download completed!');

      } catch (error) {
        console.error('Download failed:', error);
        this.$message.error(`Download failed: ${error.message}`);
      }


      // try {
      //   const response = await this.$axios({
      //     url: `/api/download/${noteid}/`,
      //     method: 'GET',
      //     responseType: 'blob',
      //   });
      //   const contentType = response.headers['content-type'];
      //   const contentDisposition = response.headers['content-disposition'];
      //   let filename = 'download';
      //   if (contentDisposition) {
      //     const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      //     const matches = filenameRegex.exec(contentDisposition);
      //     if (matches != null && matches[1]) {
      //       filename = matches[1].replace(/['"]/g, '');
      //     }
      //   }
      //   console.log('filename', filename, contentType);
      //   const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', filename);
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      // } catch (error) {
      //   console.error('下载文件时出错:', error);
      //   this.$message({ message: "File not found", type: "error" });
      // }
    },
    toggleTranslate(isopen = null) {
      // console.log("toggleTranslate", this.showTranslate , this.noteobj);
      if (isopen == null) {
        this.showTranslate = !this.showTranslate;
      } else {
        this.showTranslate = isopen;
      }
    },
    noteshare() {
      const shareurl = window.location.origin + '/share?t=' + this.noteobj.notetoken;
      this.copyToClipboard(shareurl);
    },
    closeRightPanel() {
      // 如果当前是notes页面，则关闭NewNotePage组件中的右侧面板
      if (this.noteasidekey === 'notes') {
        // 通过DOM查找NewNotePage组件并调用其closeRightPanel方法
        const newNotePage = this.$el.querySelector('.new-note-container');
        if (newNotePage && newNotePage.__vue__) {
          if (!this.isRightPanelClosed) {
            // 如果面板未关闭，则关闭它
            newNotePage.__vue__.closeRightPanel();
            this.isRightPanelClosed = true;

            // 更改按钮文本和图标
            const closeButton = this.$el.querySelector('.export .copyas');
            if (closeButton) {
              closeButton.innerHTML = '<i class="el-icon-d-arrow-left"></i> Open';
            }
          } else {
            // 如果面板已关闭，则重新打开它
            newNotePage.__vue__.openRightPanel();
            this.isRightPanelClosed = false;

            // 恢复按钮文本和图标
            const closeButton = this.$el.querySelector('.export .copyas');
            if (closeButton) {
              closeButton.innerHTML = '<i class="el-icon-close"></i> Close';
            }
          }
        }
      }

      // 如果有其他需要关闭的面板，可以在这里添加
      this.$emit('close-right-panel');
    },
    handleRightPanelClosed() {
      // 处理从NewNotePage组件发出的右侧面板关闭事件
      // 移除成功提示
    },
    handleRightPanelOpened() {
      // 处理从NewNotePage组件发出的右侧面板打开事件
      // 移除成功提示
    },
    copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message({ message: "Copied to clipboard", type: "success" });
        }).catch((err) => {
          console.error('Could not copy text: ', err);
        });
      } else {
        // 使用旧的方法复制到剪贴板
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          this.$message({ message: "Copied to clipboard", type: "success" });
        } catch (err) {
          console.error('Could not copy text: ', err);
        }
        document.body.removeChild(textArea);
      }
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      try {
        // 使用数字表示过期天数，而不是字符串
        this.$cookies.set("menuCollapsed", JSON.stringify(this.isCollapsed), {
          path: "/",
          expires: 30  // 使用数字 30 表示 30 天
        });
      } catch (error) {
        console.error("Error saving collapse state:", error);
      }
    },

    // 添加检查和更新折叠状态的方法
    checkAndUpdateCollapsedState() {
      try {
        const savedState = this.$cookies.get("menuCollapsed");
        if (savedState !== null && savedState !== undefined) {
          const parsedState = JSON.parse(savedState);
          if (this.isCollapsed !== parsedState) {
            this.isCollapsed = parsedState;
          }
        }
      } catch (error) {
        console.error("Error checking collapse state:", error);
      }
    },
    startEditTitle() {
      this.isEditingTitle = true;
      this.editingTitleText = this.noteobj.notename;
      // 获取当前标题文本的宽度
      this.$nextTick(() => {
        if (this.$refs.titleText) {
          this.titleWidth = this.$refs.titleText.offsetWidth;
        }
        this.$refs.titleInput.focus();
      });
    },
    saveTitle() {
      if (this.editingTitleText.trim()) {
        this.savenotes(this.editingTitleText.trim());
        this.isEditingTitle = false;
      }
      this.showEditIcon = false;
    },
    handleProgressUpdate(data, noteId) {
      // 忽略心跳包
      if (data.type === 'heartbeat') {
        return;
      }

      // 更新当前步骤
      this.currentProcessStep = data.type;
      this.currentStepText = data.payload?.content || 'Processing...';

      // 更新步骤列表
      const stepExists = this.processSteps.find(step => step.id === data.type);
      if (!stepExists) {
        this.processSteps.push({
          id: data.type,
          text: data.payload?.content || 'Processing...',
          status: 'current'
        });
      }

      // 更新步骤状态
      this.processSteps = this.processSteps.map(step => ({
        ...step,
        status: step.id === data.type ? 'current' : 
                this.processSteps.indexOf(step) < this.processSteps.findIndex(s => s.id === data.type) ? 
                'completed' : 'pending'
      }));

      if (this.currentProcessStep) {
        // 保存当前进度步骤到sessionStorage
        this.saveProgressStepsToStorage(noteId, {
          processSteps: this.processSteps,
          currentProcessStep: this.currentProcessStep,
          currentStepText: this.currentStepText
        });
      }

      // 处理完成状态
      if (data.type === 'creation_completed') {
        // 将所有步骤标记为已完成
        this.processSteps = this.processSteps.map(step => ({
          ...step,
          status: 'completed'
        }));

        // 停止轮询而不是关闭eventSource
        this.stopPolling();

        this.getnotes(noteId);
        
        // 清理存储的askId，因为笔记已经生成完成
        this.clearAskIdFromStorage(noteId);
        // 清理进度步骤存储
        this.clearProgressStepsFromStorage(noteId);
        
        // 延迟清理步骤状态
        setTimeout(() => {
          this.currentProcessStep = null;
          this.processSteps = [];
          this.currentStepText = '';
        }, 2000);
      } else if (data.type === 'error') {
        this.$message.error('Note generation failed: ' + data.payload?.content);
        // 停止轮询而不是关闭eventSource
        this.stopPolling();
        
        // 出错时也清理askId和进度步骤存储
        this.clearAskIdFromStorage(noteId);
        this.clearProgressStepsFromStorage(noteId);
        
        this.currentProcessStep = null;
        this.processSteps = [];
        this.currentStepText = '';
      }
    },
    startPolling(askId, noteid) {
      // 清理之前的轮询（如果存在）
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }

      // 重置轮询参数
      this.pollingInterval = 1000;
      this.consecutiveEmptyCount = 0;
      
      // 确保askId和noteid被保存到sessionStorage
      this.saveAskIdToStorage(askId, noteid);
      
      // 初始化进度步骤状态
      this.processSteps = [];
      this.currentProcessStep = 'initializing';  // 设置为有意义的初始值而不是null
      this.currentStepText = 'Starting generation...';
      
      // 保存初始进度状态
      this.saveProgressStepsToStorage(noteid, {
        processSteps: this.processSteps,
        currentProcessStep: this.currentProcessStep,
        currentStepText: this.currentStepText
      });

      console.log(`开始轮询笔记进度，askid: ${askId}, noteid: ${noteid}`);
      console.log(`轮询接口URL: /api/get_note_progress/`);

      // 立即执行一次轮询
      this.pollProgress(askId, noteid);

      // 设置定时轮询
      this.pollingTimer = setInterval(() => {
        this.pollProgress(askId, noteid);
      }, this.pollingInterval);
    },

    continuePolling(askId, noteid) {
      // 清理之前的轮询（如果存在）
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }

      // 重置轮询参数
      this.pollingInterval = 1000;
      this.consecutiveEmptyCount = 0;
      
      // 确保askId和noteid被保存到sessionStorage
      this.saveAskIdToStorage(askId, noteid);
      
      // 不重置进度步骤状态，保持已恢复的状态
      // 如果没有当前步骤，设置一个默认状态
      if (!this.currentProcessStep) {
        this.currentProcessStep = 'initializing';
        this.currentStepText = 'Continuing generation...';
      }
      
      // 保存当前进度状态
      this.saveProgressStepsToStorage(noteid, {
        processSteps: this.processSteps,
        currentProcessStep: this.currentProcessStep,
        currentStepText: this.currentStepText
      });

      console.log(`继续轮询笔记进度，askid: ${askId}, noteid: ${noteid}`);
      console.log(`轮询接口URL: /api/get_note_progress/`);

      // 立即执行一次轮询
      this.pollProgress(askId, noteid);

      // 设置定时轮询
      this.pollingTimer = setInterval(() => {
        this.pollProgress(askId, noteid);
      }, this.pollingInterval);
    },

    async pollProgress(askId, noteid) {
      console.log(`执行轮询请求 - askId: ${askId}, noteid: ${noteid}, 间隔: ${this.pollingInterval}ms`);
      
      try {
        const response = await this.$axios.post('/api/get_note_progress/', {
          askid: askId,
          noteid: noteid
        });

        const result = response.data;
        console.log('轮询响应:', result);

        if (result.code === 200) {
          if (result.has_progress && result.progress_data) {
            // 有新的进度数据
            console.log('收到新的进度数据:', result.progress_data);
            this.consecutiveEmptyCount = 0;
            this.pollingInterval = 1000; // 重置为快速轮询
            
            // 处理进度数据，使用原有的处理逻辑
            this.handleProgressUpdate(result.progress_data, noteid);
            
            // 如果是完成状态，停止轮询
            if (result.progress_data.type === 'creation_completed') {
              console.log('笔记生成完成，停止轮询');
              this.stopPolling();
            }
          } else {
            // 没有新的进度数据，调整轮询频率
            console.log(`无新进度数据，连续空结果次数: ${this.consecutiveEmptyCount + 1}`);
            this.consecutiveEmptyCount++;
            this.adjustPollingInterval();
          }
        } else if (result.code === 201) {
          // 笔记不存在或参数错误，停止轮询
          console.error('轮询错误:', result.messages);
          this.stopPolling();
          this.$message.error('查询进度失败: ' + result.messages);
        } else {
          // 服务器错误
          console.error('轮询服务器错误:', result.messages);
          this.consecutiveEmptyCount++;
          this.adjustPollingInterval();
        }
      } catch (error) {
        console.error('轮询网络错误:', error);
        this.consecutiveEmptyCount++;
        this.adjustPollingInterval();
        
        // 如果连续错误太多，停止轮询
        if (this.consecutiveEmptyCount > 20) {
          console.error('连续错误超过20次，停止轮询');
          this.stopPolling();
          this.$message.error('网络连接问题，进度查询已停止');
        }
      }
    },

    adjustPollingInterval() {
      // 根据连续空结果数量调整轮询间隔
      if (this.consecutiveEmptyCount >= 3 && this.consecutiveEmptyCount < 10) {
        // 3-9次空结果，间隔调整为2秒
        this.pollingInterval = 2000;
      } else if (this.consecutiveEmptyCount >= 10) {
        // 10次以上空结果，间隔调整为5秒
        this.pollingInterval = this.maxPollingInterval;
      }

      // 更新定时器间隔
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = setInterval(() => {
          this.pollProgress(this.currentAskId, this.currentNoteId);
        }, this.pollingInterval);
      }
    },

    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
        console.log('轮询已停止');
      }
    },

    async checkAndContinuePollingFromStorage(noteid) {
      try {
        console.log('检查前端存储的askId，noteid:', noteid);
        
        // 从sessionStorage获取保存的askId
        const storedAskId = this.getAskIdFromStorage(noteid);
        
        if (storedAskId) {
          console.log('找到存储的askId:', storedAskId);
          
          this.currentAskId = storedAskId;
          this.currentNoteId = noteid;
          
          // 恢复之前保存的进度步骤
          this.restoreProgressStepsFromStorage(noteid);
          
          // 继续轮询（不重置步骤状态）
          this.continuePolling(storedAskId, noteid);
          console.log('继续轮询笔记进度，askid:', storedAskId);
        } else {
          console.log('未找到存储的askId，笔记可能是从其他地方创建的');
        }
      } catch (error) {
        console.error('检查前端存储askId时发生错误:', error);
      }
    },

    // 保存askId到sessionStorage
    saveAskIdToStorage(askId, noteid) {
      try {
        const key = `askid_${noteid}`;
        sessionStorage.setItem(key, askId);
        console.log(`保存askId到storage: ${key} = ${askId}`);
      } catch (error) {
        console.error('保存askId到storage失败:', error);
      }
    },

    // 从sessionStorage获取askId
    getAskIdFromStorage(noteid) {
      try {
        const key = `askid_${noteid}`;
        const askId = sessionStorage.getItem(key);
        console.log(`从storage获取askId: ${key} = ${askId}`);
        return askId;
      } catch (error) {
        console.error('从storage获取askId失败:', error);
        return null;
      }
    },

    // 清理askId存储
    clearAskIdFromStorage(noteid) {
      try {
        const key = `askid_${noteid}`;
        sessionStorage.removeItem(key);
        console.log(`清理askId存储: ${key}`);
      } catch (error) {
        console.error('清理askId存储失败:', error);
      }
    },

    // 从sessionStorage获取进度步骤
    getProgressStepsFromStorage(noteid) {
      try {
        const key = `progress_steps_${noteid}`;
        const stepsData = sessionStorage.getItem(key);
        if (stepsData) {
          const steps = JSON.parse(stepsData);
          console.log(`从storage获取进度步骤: ${key} = ${JSON.stringify(steps)}`);
          return steps;
        }
        return null;
      } catch (error) {
        console.error('从storage获取进度步骤失败:', error);
        return null;
      }
    },

    // 恢复进度步骤显示
    restoreProgressStepsFromStorage(noteid) {
      try {
        const storedSteps = this.getProgressStepsFromStorage(noteid);
        if (storedSteps) {
          console.log('恢复存储的进度步骤:', storedSteps);
          
          this.processSteps = storedSteps.processSteps || [];
          this.currentProcessStep = storedSteps.currentProcessStep || null;
          this.currentStepText = storedSteps.currentStepText || 'Continuing generation...';
          
          // 确保进度组件可见
          if (!this.currentProcessStep && this.processSteps.length === 0) {
            this.currentProcessStep = 'initializing';
            this.currentStepText = 'Continuing generation...';
          }
          
          console.log('进度步骤已恢复，当前步骤:', this.currentProcessStep);
        } else {
          console.log('未找到存储的进度步骤');
          // 即使没有存储的步骤，也显示一个初始状态
          this.currentProcessStep = 'initializing';
          this.currentStepText = 'Continuing generation...';
          this.processSteps = [];
        }
      } catch (error) {
        console.error('恢复进度步骤时发生错误:', error);
        // 出错时也显示一个基本的进度状态
        this.currentProcessStep = 'initializing';
        this.currentStepText = 'Continuing generation...';
        this.processSteps = [];
      }
    },

    // 保存进度步骤到sessionStorage
    saveProgressStepsToStorage(noteid, steps) {
      try {
        const key = `progress_steps_${noteid}`;
        sessionStorage.setItem(key, JSON.stringify(steps));
        console.log(`保存进度步骤到storage: ${key} = ${JSON.stringify(steps)}`);
      } catch (error) {
        console.error('保存进度步骤到storage失败:', error);
      }
    },

    // 清理进度步骤存储
    clearProgressStepsFromStorage(noteid) {
      try {
        const key = `progress_steps_${noteid}`;
        sessionStorage.removeItem(key);
        console.log(`清理进度步骤存储: ${key}`);
      } catch (error) {
        console.error('清理进度步骤存储失败:', error);
      }
    },
  },
  beforeDestroy() {
    // 组件销毁时清理定时任务
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.removeNoteIdFromCookie();
    // 清理轮询定时器
    this.stopPolling();
  },
  beforeUpdate() {
    // 检查并同步折叠状态
    this.checkAndUpdateCollapsedState();
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/styles/home.less";

.mainview {
  max-height: 100vh !important;
  overflow: hidden !important;
  position: relative;
}

.notes-container {
  display: flex;
  transition: all 0.3s ease;
  height: calc(100% - 110px);
  /* 减去标题栏高度 */
  position: relative;
}


@keyframes slideIn {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .notes-container.with-translate {
    flex-direction: column;
  }

  .notes-container.with-translate>*:first-child,
  .translate-panel {
    width: 100%;
  }
}

aside {
  position: relative;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  overflow: hidden;

  .sidebar-toggle-btn {
    margin-top: 15px;
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    position: absolute;
    top: 20px;
    right: 10px;
    z-index: 100;

    i {
      font-size: 18px;
      color: #fff;
      padding: 8px;
      border-radius: 50%;
      background: linear-gradient(135deg, rgba(115, 102, 255, 0.2), rgba(168, 95, 255, 0.2));
      box-shadow: 0 3px 8px rgba(115, 102, 255, 0.3);
      transition: all 0.3s ease;
    }

    &:hover i {
      transform: scale(1.1);
      background: linear-gradient(135deg, rgba(115, 102, 255, 0.3), rgba(168, 95, 255, 0.3));
      box-shadow: 0 4px 10px rgba(115, 102, 255, 0.4);
    }
  }

  .expand-btn {
    position: relative;
    top: 0;
    right: 0;
    margin-top: 15px;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }

    50% {
      transform: scale(1.05);
    }

    100% {
      transform: scale(1);
    }
  }

  &.collapsed {
    width: 60px;
    min-width: 60px;

    li {
      justify-content: center;
      padding: 10px 0;

      img {
        transform: scale(1.1);
        margin-right: 0;
      }
    }

    .signin {
      justify-content: center;
      padding: 10px 0;

      img {
        margin-right: 0;
        transform: scale(1.1);
      }

      span {
        display: none;
      }
    }

    .logotitle,
    .gopaypage {
      opacity: 0;
      transform: translateX(-20px);
      visibility: hidden;
    }
  }

  li,
  .signin {
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

    img {
      transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
      width: 20px;
      height: 20px;
    }

    span {
      transition: opacity 0.2s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    }
  }

  ul {
    li {
      border-radius: 8px;
      padding: 10px 15px;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }

      &.liactiveis {
        background-color: rgba(255, 255, 255, 0.15);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

        img {
          transform: scale(1.1);
        }
      }
    }
  }

  .logotitle,
  .gopaypage {
    transition: opacity 0.2s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  .gopaypage {
    background: linear-gradient(135deg, #7366ff, #a85fff);
    border-radius: 8px;
    padding: 10px 15px;
    margin: 15px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
    transition: all 0.3s ease;

    i {
      margin-right: 8px;
      color: #fff;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 15px rgba(115, 102, 255, 0.4);
    }
  }

  .acount {
    margin-top: auto;

    .signin {
      padding: 12px 15px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      transition: all 0.3s ease;
      background-color: rgba(255, 255, 255, 0.05);

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }

      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
        border-radius: 50%;
      }

      span {
        font-size: 13px;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}

.center-icon {
  display: flex;
  justify-content: center !important;
}

/* 添加标题编辑相关样式 */
.title-editor {
  position: relative;
  display: flex;
  align-items: center;
  padding-right: 40px;
  /* 为按钮预留空间 */
  margin-bottom: 5px;
  width: 100%;
  max-width: 40vw;
  /* 设置最大宽度为40vw */
}

.title-text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 24px;
  font-weight: 600;
  padding-bottom: 2px;
  min-width: 200px;
  position: relative;
  cursor: pointer;
  padding-right: 30px !important;
  /* 为图标预留空间 */
}

.title-input {
  width: 100%;
  background: transparent;
  border: none;
  border-bottom: 1px solid #666;
  color: inherit;
  font-size: 24px;
  font-weight: 600;
  padding-bottom: 2px;
  outline: none;
  min-width: 200px;
  max-width: 40vw;
  /* 确保输入框也遵循相同的最大宽度 */

  &:focus {
    border-bottom-color: #409EFF;
  }
}

.title-edit-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.85;
  transition: all 0.3s ease;
  z-index: 10;
  cursor: pointer;

  i {
    font-size: 16px;
    padding: 6px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(115, 102, 255, 0.15), rgba(168, 95, 255, 0.15));
    color: #a85fff;
    box-shadow: 0 2px 8px rgba(115, 102, 255, 0.25);
  }

  &:hover {
    opacity: 1;
    transform: translateY(-50%) scale(1.1);

    i {
      background: linear-gradient(135deg, rgba(115, 102, 255, 0.25), rgba(168, 95, 255, 0.25));
      box-shadow: 0 3px 10px rgba(115, 102, 255, 0.35);
    }
  }
}

.title-save-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -35px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 10;

  i {
    font-size: 16px;
    padding: 6px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(115, 102, 255, 0.15), rgba(168, 95, 255, 0.15));
    color: #a85fff;
    box-shadow: 0 2px 8px rgba(115, 102, 255, 0.25);
    transition: all 0.3s ease;
  }

  &:hover i {
    transform: scale(1.1);
    background: linear-gradient(135deg, rgba(115, 102, 255, 0.25), rgba(168, 95, 255, 0.25));
    box-shadow: 0 3px 10px rgba(115, 102, 255, 0.35);
  }
}

.export {
  .copyas {
    display: flex;
    align-items: center;
    gap: 5px;

    i {
      font-size: 16px;
    }
  }
}

/* 骨架屏加载效果样式 */
.skeleton-container {
  display: flex;
  height: calc(100% - 110px);
  padding: 20px;
  gap: 20px;
}

.skeleton-header {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 50%;
}

.skeleton-title {
  height: 32px;
  width: 60%;
  background-color: #333;
  border-radius: 4px;
  margin-bottom: 10px;
  animation: pulse 1.5s infinite;
}

.skeleton-date {
  height: 18px;
  width: 40%;
  background-color: #333;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}

.skeleton-content {
  flex: 1;
  padding: 20px;
}

.skeleton-paragraph {
  height: 20px;
  width: 100%;
  background-color: #333;
  border-radius: 4px;
  margin-bottom: 15px;
  animation: pulse 1.5s infinite;
}

.skeleton-sidebar {
  width: 250px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.skeleton-sidebar-item {
  height: 100px;
  width: 100%;
  background-color: #333;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}

/* titlebox骨架屏样式 */
.titlebox-skeleton {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 15px;
}

.titlebox-l-skeleton {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.title-editor-skeleton {
  position: relative;
  display: flex;
  align-items: center;
  padding-right: 40px;
  margin-bottom: 5px;
  width: 100%;
  max-width: 40vw;
}

.title-text-skeleton {
  width: 60%;
  height: 32px;
  background-color: #ccc;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
  min-width: 200px;
}

.title-action-btn-skeleton {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background-color: #ccc;
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}

.title-date-skeleton {
  width: 40%;
  height: 18px;
  background-color: #ccc;
  border-radius: 4px;
  margin-top: 5px;
  animation: pulse 1.5s infinite;
}

.filedownload-skeleton {
  display: flex;
  align-items: center;
}

.download-skeleton {
  width: 150px;
  height: 24px;
  background-color: #333;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}

/* notes-container骨架屏样式 */
.notes-container-skeleton {
  display: flex;
  height: calc(100% - 110px);
  padding: 0 20px;
  gap: 20px;
}

.notes-main-skeleton {
  flex: 1;
  padding: 20px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.05);
}

.notes-content-skeleton {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.note-paragraph-skeleton {
  height: 20px;
  width: 100%;
  background-color: #333;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
}

.notes-sidebar-skeleton {
  width: 280px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.05);
}

.sidebar-item-skeleton {
  height: 120px;
  width: 100%;
  background-color: #333;
  border-radius: 8px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 0.6;
  }
}

/* 添加动画效果 */
@keyframes popIn {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes slideIn {
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

li img,
.signin img {
  animation: popIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

li span,
.signin span {
  animation: slideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  animation-delay: 0.1s;
}

/* 展开按钮过渡动画 */
.expand-menu-button {
  animation: fadeIn 0.5s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 添加进度步骤相关样式 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.test-steps {
  padding: 10px 15px;
  margin-bottom: 10px;
  
  .el-button {
    width: 100%;
    background: linear-gradient(135deg, #42b983, #33d977);
    border: none;
    
    &:hover {
      background: linear-gradient(135deg, #3ca876, #2ec76a);
      transform: translateY(-1px);
    }
  }
}
</style>
